<div class="loader-container">
  <div style="color: #404040" class="la-line-scale la-3x">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
